import { Controller } from "@hotwired/stimulus";

// Nedtælling til næste vurderingsperiode. Serveren er autoritativ: når perioden
// er udløbet, hentes siden igen, og den nye periode oprettes server-side.
export default class extends Controller {
  static targets = ["output"];
  static values = { endsAt: String };

  connect() {
    this.endsAt = new Date(this.endsAtValue).getTime();
    this.timer = setInterval(() => this.tick(), 1000);
    this.tick();
  }

  disconnect() {
    clearInterval(this.timer);
  }

  tick() {
    const remaining = Math.max(0, Math.floor((this.endsAt - Date.now()) / 1000));
    const minutes = String(Math.floor(remaining / 60)).padStart(2, "0");
    const seconds = String(remaining % 60).padStart(2, "0");
    this.outputTarget.textContent = `${minutes}:${seconds}`;

    if (remaining === 0) {
      clearInterval(this.timer);
      window.Turbo.visit(window.location.href, { action: "replace" });
    }
  }
}
